import { Component, OnInit, ViewChild } from '@angular/core';
import { TemaService } from '../../../providers/tema.service';
import { MatDialog, Sort, PageEvent, MatSnackBar, MatSort, MatExpansionPanel } from '@angular/material';
import { PropuestasService } from '../../../providers/propuestas.service';
import { ReplaySubject, Subscription } from 'rxjs';
import { DialogConfirmarPropuesta, DialogAccionesPropuesta, DialogConfirmarPropuestaArchivada } from '../acciones-propuesta/acciones-propuesta.component';
import { DragulaService } from 'ng2-dragula';
import { Router } from '@angular/router';

@Component({
  selector: "app-panel-propuestas",
  templateUrl: "./panel-propuestas.component.html",
  styleUrls: ["./panel-propuestas.component.scss"],
})
export class PanelPropuestasComponent implements OnInit {
  readonly titulo = "Propuestas";
  public tema: String = "";
  error: string = "";
  traerPropuestasTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  flag_sin_contacto_ni_cliente: boolean = true;
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  getPropuestasSuscripcion = new Subscription();
  sort: Sort = { active: "", direction: "" };
  page: PageEvent = new PageEvent();
  filtros: any = {
    generico: "",
  };
  flujo_actual: any;
  BAG = "DRAGULA_FACTS";
  subs = new Subscription();
  public max_progreso: 5;
  tieneFiltrosOrdenPaginado = false;
  panelConFiltroActivo = false;
  ultimo_estado: any;
  flujos: any;
  mostrar_archivados: boolean = false;
  @ViewChild(MatSort) matSort: MatSort;
  @ViewChild("filtrosPanel") set filtrosPanel(v: MatExpansionPanel) {
    if (typeof v != "undefined") {
      setTimeout(() => {
        this.checkPageState();
        if (this.panelConFiltroActivo) {
          v.open();
        }
      }, 25);
    }
  }
  public datos = []; // array de datos obtenidos
  public listadoPropuestas = [];
  public estados_propuestas = [];
  //public acciones: AccionesPropuestaComponent;
  contador: any = {};
  inTransit: boolean;
  constructor(
    private temaServicio: TemaService,
    public dialog: MatDialog,
    private propuestaService: PropuestasService,
    public snackBar: MatSnackBar,
    private dragulaService: DragulaService,
    private router: Router,
  ) {
    this.subs.add(
      dragulaService.drop(this.BAG).subscribe(({ target, el }) => {
        // console.log(target,'tar');
        this.cambiarEstado(el, target);
      })
    );
    this.subs.add(
      dragulaService.over(this.BAG).subscribe(({ container }) => {
        this.cambiarColor(container);
      })
    );
  }

  ngOnInit() {
    this.propuestaService.getFlujos().subscribe(
      respuesta => {
        this.flujos = respuesta.data;
        this.flujo_actual = this.flujos[0];
        this.inicializarPanel();
      }
    )

  }

  verPerfilCliente(element: any) {
    console.log(element);
    // Supongamos que el elemento contiene información relevante sobre el cliente,
    // como el ID del cliente o el nombre. Puedes usar esta información para construir la URL del perfil del cliente.
     // Por ejemplo, asumiendo que el ID del cliente está en una propiedad llamada 'clienteId'
    if(element.entidades[0].IdEntidad == null || element.entidades[0].IdEntidad == ''){
      console.log('voy a contacto');
      let clienteId = element.contacto[0].IdContacto;
      this.router.navigate(['/logueado/contactos/contacto-detalle', clienteId]);
    }else{
      console.log('voy a cliente');
      let clienteId = element.entidades[0].IdEntidad;
      this.router.navigate(['/logueado/prospectos/prospecto-detalle/', clienteId]);
    }

    // Navegar al perfil del cliente, pasando el ID del cliente como parte de la URL
    
  }
  inicializarPanel() {
    this.traerPropuestas();
    this.obtenerTotal();
  }

  _limpiarPageState() {
    // filtros
    localStorage.setItem("ver_propuestas_panel_filtros", null);
    // paginado
    localStorage.setItem("ver_propuestas_panel_paginado", null);
    // sort
    localStorage.setItem("ver_propuestas_panel_sort", null);
  }

  recordarPageState() {
    // filtros
    localStorage.setItem(
      "ver_propuestas_panel_filtros",
      JSON.stringify(this.filtros)
    );
    // paginado
    localStorage.setItem(
      "ver_propuestas_panel_paginado",
      JSON.stringify(this.page)
    );
    // sort
    localStorage.setItem(
      "ver_propuestas_panel_sort",
      JSON.stringify(this.sort)
    );
  }

  checkPageState(): boolean {
    this.tieneFiltrosOrdenPaginado = false;
    // checkear si hay almenos un filtro aplicado
    this.panelConFiltroActivo = false;
    for (let propiedad in this.filtros) {
      if (this.filtros[propiedad]) {
        this.tieneFiltrosOrdenPaginado = true;
        this.panelConFiltroActivo = true;
        break;
      }
    }
    // checkear si hay paginado
    if (this.page.pageIndex != 0) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    // checkear si hay ordenamiento
    if (
      this.sort.active != "" &&
      (this.sort.active != "PropuestaNombre" || this.sort.direction != "desc")
    ) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    return this.tieneFiltrosOrdenPaginado;
  }
  restaurarPageState() {
    // filtros
    let localFiltros = JSON.parse(
      localStorage.getItem("ver_propuestas_panel_filtros")
    );
    if (localFiltros != null) {
      this.filtros = localFiltros;
    } else {
      for (let propiedad in this.filtros) {
        this.filtros[propiedad] = "";
      }
    }
    // paginado
    let localPaginado = JSON.parse(
      localStorage.getItem("ver_propuestas_panel_filtros")
    );
    if (localPaginado != null) {
      this.page = localPaginado;
    } else {
      this.page.pageIndex = 0;
      this.page.pageSize =
        +localStorage.getItem("ver_propuestas_panel_paginado_size") || 10;
      this.page.length = 0;
    }
    // sort
    let localSort = JSON.parse(
      localStorage.getItem("ver_propuestas_panel_sort")
    );
    if (localSort != null) {
      // para el sort tenemos que hacerlo con un "set" porque arregla un bug de "matSort"
      this.setActiveSortProgrammatically(localSort.active, localSort.direction);
    } else {
      this.setActiveSortProgrammatically("IdPropuesta", "desc");
    }
    this.traerPropuestas();
  }
  /**
   * Para arreglar un bug de angular usamos esta funcion para ordenar
   */
  setActiveSortProgrammatically(active, direction): void {
    let interval = setInterval(() => {
      if (this.matSort) {
        clearInterval(interval);
        if (this.sort.active != active || this.sort.direction != direction) {
          this.sort = <MatSort>{
            active: active,
            direction: direction,
          };
          this.matSort.sort({
            id: active,
            start: direction,
            disableClear: true,
          });
          // ugly hack!
          const activeSortHeader = this.matSort.sortables.get(active);
          if (activeSortHeader) {
            activeSortHeader["_setAnimationTransitionState"]({
              fromState: direction,
              toState: "active",
            });
          }
        }
      }
    }, 0);
  }

  sortData(sort: Sort) {
    this.sort = sort;
    this.traerPropuestas();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem(
      "ver_" + this.titulo + "_paginado_size",
      pageEvent.pageSize.toString()
    );
    this.page = pageEvent;
    this.traerPropuestas();
  }

  onFiltro() {
    this.page.pageIndex = 0;
  }
  reiniciarPageState() {
    this._limpiarPageState();
    this.restaurarPageState();
  }

  cambiarFlujo(event) {
    this.flujo_actual = event.value;
    this.inicializarPanel();
  }


  /***
   * Funcion para traer los estados de propuestas
   */

  traerEstadosPropuestas(): void {
    this.contador = {};
    this.cargando = true;
    this.propuestaService.getEstadosPropuestas({ 'filtros': { 'flujo_id': this.flujo_actual.id } }).subscribe(
      respuesta => {
        this.estados_propuestas = respuesta.estados;
        this.estados_propuestas.forEach(element => {
          this.contador[element.orden] = 0;
        });
        this.buscarUltimoEstado();
        this.obtenerTotal()
      }
    )
  }

  buscarUltimoEstado() {
    this.ultimo_estado = this.estados_propuestas[this.estados_propuestas.length - 1].id;
  }

  /**
   * Funcion para traer las propuestas
   */
  traerPropuestas(): void {
    this.cargando = true;
    this.traerEstadosPropuestas()
    this.listadoPropuestas = [];
    this.mostrar_archivados = false;
    this.filtros['ver_archivadas'] = 0;
    this.filtros['panel'] = 1;
    this.filtros['flujo_id'] = this.flujo_actual.id;
    this.propuestaService.getPropuestas(
      {
        page: null,
        pageSize: null,
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtros)
    ).subscribe(respuesta => {
      if (respuesta.estado == 1 && respuesta.data) {
        this.listadoPropuestas = respuesta.data;
        this.listadoPropuestas.forEach(element => {
          this.contador[element.propuestaEstado.EstPropNivel]++;
        });
      }
      // console.log(this.contador, 'contador');

      this.cargando = false;
    },
      () => {
        this.cargando = false;
      }
    );
  }
  /**
   * Funcion para traer las propuestas
   */
  verArchivados(): void {
    this.cargando = true;
    this.listadoPropuestas = [];
    this.mostrar_archivados = true;
    this.filtros['ver_archivadas'] = 1;
    this.propuestaService
      .getPropuestas(
        {
          page: null,
          pageSize: null,
        },
        {
          sort: this.sort.active,
          order: this.sort.direction,
        },
        Object.assign(this.filtros)

      )
      .subscribe(
        (respuesta) => {
          if (respuesta.estado == 1 && respuesta.data) {
            this.listadoPropuestas = respuesta.data;
            // console.log(this.listadoPropuestas)
          }
          this.cargando = false;
        },
        () => { },
        () => { }
      );
  }
  obtenerTotal(): void {

    this.propuestaService.getPropuestas(
      {
        page: null,
        pageSize: null
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtros)
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          this.listadoPropuestas = respuesta.data;
          // this.listadoPropuestas.forEach(element => {
          //   this.contador[element.propuestaEstado.IdEstadoPropuesta]++;
          // });

        }
      }, () => {

      }, () => {

      });
  }

  filterItemsOfType(type) {
    return this.listadoPropuestas.filter((x) => x.PropuestaEstado == type);
  }
  panel_1: string;
  cambiarColor(div) {
    this.panel_1 = div.id;
  }
  /**
   *
   * Funcion para el cambio de estado en panel, al arrastrar una propuesta
   */
  cambiarEstado(propuestaElement, targetElement) {
    // console.log('Es por acá rei');

    this.panel_1 = null;
    let cortarPropuestaEstado = propuestaElement.id.split("-");
    let cortarEstado = targetElement.id.split("-");
    let propuesta = cortarPropuestaEstado[1];
    let estado = cortarEstado[3];
    // if (ev.target.id == source) {
    //   return false;
    // }
    if (targetElement.id == "panel-prop-estado-" + this.ultimo_estado) {
      this.propuestaFinalizada(propuesta, estado);
      return false;
    }
    let datos = {
      "IdPropuesta": propuesta,
      "estado_id": estado,
      "idCliente": localStorage.getItem('idCliente')
    }
    this.propuestaService.cambiarEstado(datos).subscribe(
      (respuesta) => {
        if (respuesta.estado == 1) {
          //TODO: Ver que hacer cuando esta OK el cambio
          //this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
          this.traerPropuestas();
          // this.obtenerTotal(respuesta.data);
          // this.obtenerTotal();
          // if (ev.target.id == "panel-prop-estado-3" && source == "panel-prop-estado-4") {
          //   this.traerPropuestas();
          // }
        } else {
          this.error = respuesta.mensaje;
          this.traerPropuestas();
        }
      },
      (error) => {
        this.error = error;
        this.traerPropuestas();
      }
    );
  }

  allowDrop(ev) {
    ev.preventDefault();
  }
  /**
   *
   * FUnciones de Drag an drop
   */
  colorProgreso(perc, min, max) {
    var base = max - min;

    if (base == 0) {
      perc = 100;
    } else {
      perc = ((perc - min) / base) * 100;
    }
    var r,
      g,
      b = 0;

    if (perc < 50) {
      r = 255;
      g = Math.round(5.1 * perc);
    } else {
      g = 255;
      r = Math.round(510 - 5.1 * perc);
    }
    var h = r * 0x10000 + g * 0x100 + b * 0x1;
    return "#" + ("000000" + h.toString(16)).slice(-6);
  }

  colorFuente(perc, min, max) {
    var base = max - min;
    if (base == 0) {
      perc = 100;
    } else {
      perc = ((perc - min) / base) * 100;
    }
    if (perc < 50) {
      return "#" + "ffffff";
    } else {
      return "#" + "000000";
    }
  }
  drag(ev) {
    ev.dataTransfer.setData("text", ev.target.id);
  }
  dropDisable(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    return false;
  }

  editarPropuesta(propuesta, tipo?) {
    // console.log('PROPUESTA', propuesta);
    // console.log('TIPO', tipo);
    let dilogEditar = this.dialog.open(DialogAccionesPropuesta, {
      width: "70vw",
      data: { propuesta, tipo },
    });
    dilogEditar.componentInstance.onCreado.subscribe(() => {
      this.traerPropuestas();
    });
    dilogEditar.afterClosed().subscribe((resultado) => { });
  }
  propuestaFinalizada(propuesta, estado) {
    let dilogEditar = this.dialog.open(DialogConfirmarPropuesta, {
      width: "30vw",
      data: { propuesta, estado },
      disableClose: true,
    });
    dilogEditar.componentInstance.onFinalizado.subscribe(() => {
      this.traerPropuestas();
    });
    dilogEditar.afterClosed().subscribe((resultado) => { });
  }
  confirmarPropuestaArchivda(propuesta) {
    let dialogConfirmarArchivada = this.dialog.open(
      DialogConfirmarPropuestaArchivada,
      {
        width: "30vw",
        data: { IdPropuesta: propuesta, tipo: 'archivar' },
        disableClose: true,
      }
    );
    dialogConfirmarArchivada.componentInstance.onFinalizado.subscribe(() => {
      this.traerPropuestas();
    });
    dialogConfirmarArchivada.afterClosed().subscribe((resultado) => {
      this.traerPropuestas();

    });
  }


  confirmarPropuestaDesarchivda(propuesta) {
    let dialogConfirmarArchivada = this.dialog.open(
      DialogConfirmarPropuestaArchivada,
      {
        width: "30vw",
        data: { IdPropuesta: propuesta, tipo: 'desarchivar' },
        disableClose: true,
      }
    );
    // dialogConfirmarArchivada.componentInstance.onFinalizado.subscribe(() => {
    //   this.traerPropuestas();
    // });
    dialogConfirmarArchivada.afterClosed().subscribe((resultado) => {
      this.traerPropuestas();

    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
